//
export default [
    {
        text: 'código proveedor',
        value: 'provider_product_code',
        input: {
            type: 'text-field',
        },
        width: '13%',
    },
    {
        text: 'código interno',
        value: 'internal_code',
        width: '13%',
    },
    {
        text: 'códigos upc',
        value: 'upc_codes',
        component: {
            type: 'chip-list',
        },
        width: '10%',
    },
    {
        text: 'nombre',
        value: 'name',
        component: {
            custom: 'wh_product_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'stock',
        value: 'stock',
        align: 'right',
        format: 'number',
        width: '10%',
    },
    {
        text: 'cantidad',
        value: 'quantity',
        align: 'right',
        format: 'number',
        input: {
            reverse: true,
            type: 'float-field',
        },
        width: '10%',
    },
]
